import { createFileRoute, redirect } from "@tanstack/react-router"
import { campaignQuery } from "@/lib/queries"

/** A draft opens where the author left off; anything approved opens on its results. */
export const Route = createFileRoute("/w/$workspace/campaigns/$campaignId/")({
  beforeLoad: async ({ context, params }) => {
    const campaign = await context.queryClient.ensureQueryData(campaignQuery(params.workspace, params.campaignId))
    if (campaign.status === "draft") throw redirect({ to: "/w/$workspace/campaigns/$campaignId/audience", params })
    throw redirect({ to: "/w/$workspace/campaigns/$campaignId/results", params })
  },
})
